 /*@ngInject*/
    const LoadSubmissionAttachmentsRepository = function (baseRepository, attachmentUtil) {

        angular.extend(this, baseRepository);

        this.loadSubmissionAttachments = function (submissionId) {
            let url = '/rest/Submission/' + submissionId + '/Attachments';

            return this.get(url);
        };

        this.loadSharedSubmissionAttachments = function (submissionId) {
            let url = '/rest/Submission/' + submissionId + '/Attachments',
                config = {
                    params: {
                        shared: true
                    }
                };
            return this.get(url, config);
        };

    };

    angular.module('gw-um-submission')
        .service('loadSubmissionAttachmentsRepository', LoadSubmissionAttachmentsRepository);
